{
    "Policies.home": "FR: Home",
    "Policies.dashboard": "FR: Dashboard",
    "Policies.policies": "FR: Policies",
    "Policies.bordereaux": "FR: Bordereaux",
    "Policies.newquote": "FR: New Quote",
    "Policies.leads": "FR: Leads",
    "Policies.search": "FR: Clients",
    "Policies.allBrokers": "FR: All Brokers",
    "Policies.allBrokerage": "FR: All Brokerage"
}
